<div class="flex flex-col text-center">
  @if(normalExtenders() !== null &&
  hasPermission(permissions.see_io_addon_normal)){
  <app-normal-io [normalExtenders]="normalExtenders()!" class="mb-5" />}
  @if(analogExtenders()!== null &&
  hasPermission(permissions.see_io_addon_analog)){
  <app-analog-io [analogExtenders]="analogExtenders()!" class="mb-5" />}
  @if(gen2Extenders() !== null && hasPermission(permissions.see_io_addon_gen2)){
  <app-gen2-io [gen2Extenders]="gen2Extenders()!" />}
</div>
